import { http, https } from '../../global/axios';
import { SERVER_HOST, NEW_SERVER_HOST } from '../../global/constants';

export const sso = (token) => {
  return https.post(`${NEW_SERVER_HOST}/v1/api/unsafe/system/auth/token/validate`, {}, {
    headers: {
      'token': token
    }
  });
}


// 获取登陆code
export const getQrcode = () => {
  return `${SERVER_HOST}/v1/system/weixin/login/auth.json`;
};

// 获取token
export const queryCurrent = (ssid) => {
  return http.post(`v1/system/weixin/login/login.json?ssid=${ssid}`);
};

// 众包协议
export const accept = () => {
  return https.post(`v1/system/weixin/login/accept.json`);
};

// 退出登陆
export const logout = () => {
  let ssid = localStorage.getItem('ssid');
  if (ssid) {
    https.post(`${NEW_SERVER_HOST}/v1/api/unsafe/system/auth/token/destroy`, {}, {
      headers: {
        'token': ssid
      }
    });
    localStorage.removeItem('ssid');
  }
  return http.post(`v1/system/weixin/login/logout.json`);
};

// 注销账号
export const logOff = (parames) => {
  return https.post(`v1/system/user/cancel.json`, parames)
}

// 获取星级 废弃
export const getStar = () => {
  return http.post(`v1/skill/exp.json`);
};

// 获取个人经验
export const getExp = (parames) => {
  return http.post(`tags/user/experience/list.json`, parames);
};

// 获取个人经验 不分页
export const getExpNoPage = (parames) => {
  return http.post(`tags/user/experience/list_no_page.json`, parames);
};
// 获取做题记录
export const getProblemLog = (parames) => {
  return http.post(`v2/tags/libs/mg/logs.json`, parames);
};

// 获取结果页面
export const getDetail = (parames) => {
  return http.post(`v2/tags/libs/mg/detail.json`, parames);
};

// 获取考核列表
export const getExamine = (parames) => {
  return http.post(`v1/tags/study/logs.json`, parames);
};

// 考核查看页面
export const lookAtExamine = (parames) => {
  return http.post(`v1/tags/study/detail.json?gid=` + parames.gid);
};

// 获取选项列表
export const getOptionList = () => {
  return http.post(`v1/amount/type/list.json`);
};

// 获取账目列表
export const getIncomeList = (parames) => {
  return http.post(`v1/amount/income/list.json`, parames);
};

// 获取验收额明细
export const getSettlementList = (parames) => {
  return http.post(`v1/amount/settlement/logs.json`, parames);
};

// 获取冻结明细
export const getFreezeList = (parames) => {
  return http.post(`v1/amount/income/freeze/list.json`, parames);
};

// 获取提现金额列表
export const getWithdrawals = () => {
  return http.post(`v1/draw/cash/options.json`);
};

// 获取未读取消息
export const getUnreadMessage = (parames) => {
  return http.post(`/v1/common/notice/unreadlist.json`, parames);
};

// 获取提现短信验证码
export const getWithdrawalsCode = (parames) => {
  return https.post(`v1/draw/cash/code.json`, parames);
};

// 对公转账
export const getVerifyStatus = () => {
  return http.post(`v1/common/supplier/verify.json`);
};

// 实名认证
export const authentication = (params) => {
  return https.post(`v1/draw/cash/aliyun/certify.json`, params);
};

// 获取最近5条消息
export const recentList = (params) => {
  return http.post(`v1/common/notice/unreadlist.json`, params);
};

// 获取消息列表
export const messageList = (params) => {
  return http.post(`v1/common/notice/all_list.json`, params);
};
// 获取经验值明细
export const detailExp = (params) => {
  return http.post(`v2/tags/practicelib/details.json`, params);
};

// 全部消息标记已读
export const readAll = (params) => {
  return http.post(`v1/common/notice/read_all.json`, params);
};

// 某个消息标记已读
export const readMsg = (params) => {
  return http.post(`v1/common/notice/read_message.json`, params);
};

// 签署数据委托协议
export const readProtocol = () => {
  return http.post(`v1/common/supplier/read/protocol.json`);
};

// 获取实名认证信息
export const detailTax = (params) => {
  return http.post(`v1/draw/cash/amount/count.json?amount=${params.amount}&trade_type=${params.trade_type}`);
};

// 获取供应商数据
export const getVerify = () => {
  return https.post(`v1/common/supplier/verify.json`);
};

// 提交供应商数据
export const subSupplier = (params) => {
  return https.post(`v1/common/supplier/submit.json`, params);
};

// 供应商提现
export const subTransfer = (params) => {
  return https.post(`v1/draw/cash/supplier/withdraw.json`, params);
};

// 提现
export const drawCash = (params) => {
  return https.post(`v1/draw/cash/pay.json`, params);
};

// banner
export const banner = (type) => {
  return https.post(`v1/common/banner/list.json?type=` + type)
}

// 手机登录 获取验证码
export const getLoginCode = (params) => {
  return http.post(`/v1/system/mobile/login/code.json?mobile=${params.mobile}`)
}

// 手机登录
export const loginMobile = (params) => {
  return http.post(`/v1/system/mobile/login/validate.json?mobile=${params.mobile}&code=${params.code}`)
}

//绑定微信
export const bindWechat = () => {
  return http.post(`/v1/system/bind/weixin/auth.json`)
}

//校验微信是否绑定成功
export const verifyWechat = (params) => {
  return https.post(`/v1/system/bind/weixin/state.json?token=${params}`)
}

//绑定手机 获取验证码
export const getBindCode = (params) => {
  return http.post(`/v1/system/bind/code.json?mobile=${params.mobile}`)
}

//绑定手机号
export const bindMobile = (params) => {
  return https.post(`/v1/system/bind/mobile.json?mobile=${params.mobile}&code=${params.code}`)
}

//更新昵称
export const changeNick = (params) => {
  return https.post(`/v1/system/setting/update/nickname.json?nickname=${params.nick}`)
}

//获取做任务记录
export const getTaskLogs = (params) => {
  return http.post(`/v2/tags/task/s_list.json`, params)
}

// 获取做题记录（某人某天某个任务做了什么题）
export const getLibLogs = (params) => {
  return http.post(`/v2/tags/libs/mg/statistic/logs.json`, params)
}

// 更换微信绑定
export const changeBindWx = () => {
  return https.post(`/v1/system/bind/weixin/auth.json`)
}

// 查询绑定状态
export const verifyBindWx = (token) => {
  return https.post(`/v1/system/bind/weixin/state.json?token=` + token)
}

// 修改手机号
export const changePassword = (password) => {
  return https.post(`/v1/system/setting/update/password.json?password=` + password)
}

// 修改支付宝账号
export const changeAlipay = (alipay) => {
  return https.post(`/v1/system/setting/update/alipay.json?alipay=` + alipay)
}

// 修改昵称
export const changeNickName = (nick) => {
  return https.post(`/v1/system/setting/update/nickname.json?nickname=` + nick)
}

// 获取用户画像
export const getUserProfile = () => {
  return http.post(`/v1/system/setting/profile/info.json`)
}

// 获取用户画像
export const updateUserProfile = (params) => {
  return https.post(`/v1/system/setting/update/profile.json`, params)
}

// 赚钱排行
export const amountTop = () => {
  return http.post(`/v1/draw/income/top.json`);
};

// 活动接口
export const activityDetail = () => {
  return http.post(`/v2/activity/qc/award/activity/detail.json`);
};

// 个人排名查询
export const getUserRanking = () => {
  return http.post(`/v1/draw/income/topman.json`);
}

// 申请成为质检员
export const applyQc = (data) => {
  return https.post(`/v1/system/setting/apply/qc.json`, data);
}

// 申请成为质检员
export const publicNotice = (data) => {
  return https.post(`/v3/public/notice/list.json`, data);
}

// 赚钱排行
export const userShareExp = () => {
  return http.post(`/v3/public/share/exp/list.json`);
};

// 申请成为质检员
export const deviceInfo = (data) => {
  return https.post(`/v1/system/setting/device/info.json`, data);
}

// 查询做题时长
export const queryMarkDuration = () => {
  return https.post('/v1/system/clock/dotime.json', {})
}

// 用户打卡
export const signClock = () => {
  return https.post('/v1/system/clock/clockin.json', {})
}